import type {AutomationWorkflowAudienceAction} from 'src/action-creators/automation-workflow-audience';
import type {AudienceList} from 'src/types/audience-list';
import type {TalentPoolHierarchy} from 'src/types/talent-pools';
import {
  UPDATE_STATE,
  RECEIVE_SELECTED_LISTS,
  SET_INCLUDED_LISTS,
  SET_EXCLUDED_LISTS,
  SET_TALENT_POOL_INCLUDED_LISTS,
  SET_TALENT_POOL_EXCLUDED_LISTS,
  RESET,
} from 'src/action-creators/automation-workflow-audience';


export type AutomationWorkflowAudienceState = {
  includedLists: Map<string, Partial<AudienceList>>;
  excludedLists: Map<string, Partial<AudienceList>>;
  talentPoolIncludedLists: Map<string, Partial<TalentPoolHierarchy>>;
  talentPoolExcludedLists: Map<string, Partial<TalentPoolHierarchy>>;
};

const initialState = {
  includedLists: new Map(),
  excludedLists: new Map(),
  talentPoolIncludedLists: new Map(),
  talentPoolExcludedLists: new Map(),
} as const;

export default (
  state: AutomationWorkflowAudienceState | null | undefined = initialState,
  action: AutomationWorkflowAudienceAction,
): AutomationWorkflowAudienceState => {
  switch (action.type) {
    case UPDATE_STATE: {
      // @ts-expect-error - TS2322 - Type '{ includedLists?: Map<string, Partial<AudienceList>> | undefined; excludedLists?: Map<string, Partial<AudienceList>> | undefined; talentPoolIncludedLists?: Map<...> | undefined; talentPoolExcludedLists?: Map<...> | undefined; }' is not assignable to type 'AutomationWorkflowAudienceState'.
      return {
        ...state,
        ...action.payload,
      };
    }
    case RECEIVE_SELECTED_LISTS: {
      // @ts-expect-error - TS2322 - Type '{ includedLists: Map<string, Partial<AudienceList>>; excludedLists: Map<string, Partial<AudienceList>>; talentPoolIncludedLists?: Map<...> | undefined; talentPoolExcludedLists?: Map<...> | undefined; }' is not assignable to type 'AutomationWorkflowAudienceState'.
      return {
        ...state,
        includedLists: new Map([
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.includedLists.entries(),
          ...action.payload.includedLists.entries(),
        ]),
        excludedLists: new Map([
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.excludedLists.entries(),
          ...action.payload.excludedLists.entries(),
        ]),
      };
    }
    case SET_INCLUDED_LISTS: {
      // @ts-expect-error - TS2322 - Type '{ includedLists: Map<string, Partial<AudienceList>>; excludedLists?: Map<string, Partial<AudienceList>> | undefined; talentPoolIncludedLists?: Map<...> | undefined; talentPoolExcludedLists?: Map<...> | undefined; }' is not assignable to type 'AutomationWorkflowAudienceState'.
      return {
        ...state,
        includedLists: action.payload,
      };
    }
    case SET_EXCLUDED_LISTS: {
      // @ts-expect-error - TS2322 - Type '{ excludedLists: Map<string, Partial<AudienceList>>; includedLists?: Map<string, Partial<AudienceList>> | undefined; talentPoolIncludedLists?: Map<...> | undefined; talentPoolExcludedLists?: Map<...> | undefined; }' is not assignable to type 'AutomationWorkflowAudienceState'.
      return {
        ...state,
        excludedLists: action.payload,
      };
    }
    case SET_TALENT_POOL_INCLUDED_LISTS: {
      // @ts-expect-error - TS2322 - Type '{ talentPoolIncludedLists: Map<string, Partial<TalentPoolHierarchy>>; includedLists?: Map<string, Partial<AudienceList>> | undefined; excludedLists?: Map<...> | undefined; talentPoolExcludedLists?: Map<...> | undefined; }' is not assignable to type 'AutomationWorkflowAudienceState'.
      return {
        ...state,
        talentPoolIncludedLists: action.payload,
      };
    }
    case SET_TALENT_POOL_EXCLUDED_LISTS: {
      // @ts-expect-error - TS2322 - Type '{ talentPoolExcludedLists: Map<string, Partial<TalentPoolHierarchy>>; includedLists?: Map<string, Partial<AudienceList>> | undefined; excludedLists?: Map<...> | undefined; talentPoolIncludedLists?: Map<...> | undefined; }' is not assignable to type 'AutomationWorkflowAudienceState'.
      return {
        ...state,
        talentPoolExcludedLists: action.payload,
      };
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'AutomationWorkflowAudienceState | null' is not assignable to type 'AutomationWorkflowAudienceState'.
  return state;
};
